import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { NetworkService } from "../../core/services/network.service";
import { LanguageService } from "../../core/services/language.service";
import { EventsService } from "../../core/services/events.service";
import { LANGUAGE_WAS_CHANGED } from "../../app.constants";

@Component({
    selector: 'app-info',
    templateUrl: './contact-info.component.html',
    styleUrls: ['./contact-info.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ContactInfoComponent implements OnInit {
    fetchedData;
    currentLanguage: string;
    currentSlug: string;
    info = {
        'name': '',
        'description': ''
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private network: NetworkService,
        private languageService: LanguageService,
        private eventService: EventsService
    ) {}

    ngOnInit(): void {
        this.currentLanguage = this.getCurrentLanguage();
        this.currentSlug = this.route.snapshot.paramMap.get('slug');
        this.fetchContactInfo();

        this.eventService.on(LANGUAGE_WAS_CHANGED).subscribe(() => {
            this.currentLanguage = this.getCurrentLanguage();
            this.createInformationObject();
        });

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

                if (this.route.snapshot.data.name == 'pages' &&
                    this.route.snapshot.params.slug !== this.currentSlug) {

                    this.currentSlug = this.route.snapshot.paramMap.get('slug');
                    this.fetchContactInfo();
                }
            }
        });
    }

    getCurrentLanguage(): string {
        const activeLang = this.languageService.getActiveLanguage();

        return activeLang;
    }

    fetchContactInfo() {
        this.network.fetchContactInfo(this.currentSlug)
            .then(response => {
                this.fetchedData = response;
                this.createInformationObject();
            });
    }

    createInformationObject(): void {
        this.info.name = this.fetchedData['name_' + this.currentLanguage];
        this.info.description = this.fetchedData['description_' + this.currentLanguage];
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/pages/contact-info/contact-info.component.ts